module.exports = __webpack_public_path__ + "img/visibility-off.5d71a72f.svg";